<template>
  <v-container>
    <AdminSidebarMenu v-if="isAdmin"></AdminSidebarMenu>
    <SalesSidebarMenu v-else></SalesSidebarMenu>
  </v-container>
</template>

<script>
import { Decode } from '@/services'
export default {
  components: {
    AdminSidebarMenu: () => import('@/views/Gracz/AdminSidebarMenu'),
    SalesSidebarMenu: () => import('@/views/Gracz/SalesSidebarMenu')
  },
  data () {
    return {
      isAdmin: null,
      statuschangeUserProfileAdmin: false
    }
  },
  created () {
    this.$EventBus.$emit('getPath')
    this.$EventBus.$on('changeNav', this.changeNav)
    window.addEventListener('storage', function (event) {
      if (event.key === 'oneData' && !event.newValue) {
        window.location.assign('/')
      }
    })
    // mock data เพื่อเปลี่ยน role (admin, superAdmin, sales)
    this.getUserDetail()
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$EventBus.$on('changeToAdminProfile', this.changeUserProfileAdmin)
    this.$EventBus.$on('changeToAdminShop', this.changeShopAdmin)
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  methods: {
    changeUserProfileAdmin () {
      this.statuschangeUserProfileAdmin = true
      this.isAdmin = false
    },
    changeShopAdmin () {
      this.statuschangeUserProfileAdmin = false
      this.isAdmin = true
    },
    async getUserDetail () {
      this.$store.commit('openLoader')
      await this.$store.dispatch('actionsGraczUserDetail')
      var response = await this.$store.state.ModuleGraczUser.stateGraczUserDetail
      if (response.message === 'Get user detail selling success') {
        this.$store.commit('closeLoader')
        var shopData
        if (localStorage.getItem('UserDetailSelling') !== null) {
          var userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
          var shopIndex = response.data.list_shop_detail.findIndex(e => e.seller_shop_id === userDetailSelling.seller_shop_id)
          shopData = response.data.list_shop_detail[shopIndex]
        }
        if (shopData.position === 'sales') {
          this.isAdmin = false
        } else {
          // super_admin and admin => is true
          // เช็คว่าใช่ เมนูบัญชีของฉันไหม ถ้าใช่จะให้ isAdmin = false เพื่อจะไปใช้ เมนูบัญชีของฉันเดียวกับ sales
          if (this.$router.currentRoute.name === 'GraczUserProfileDetail' || this.$router.currentRoute.name === 'GraczSalesOrder' || this.$router.currentRoute.name === 'GraczSalesOrderDetail' || this.$router.currentRoute.name === 'GraczSalesCustomerList') {
            this.isAdmin = false
          } else {
            this.isAdmin = true
          }
        }
      } else if (response.message === 'This user is unauthorized.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else if (response.message === 'Not access this function.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else {
        this.$store.commit('closeLoader')
        var [msg, iconMsg] = this.getErrorMsg(response.message)
        this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Channel not found. Please check and try again.') {
        return ['ไม่พบ Channel โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Shop not found. Please check and try again.') {
        return ['ไม่พบร้านค้า โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>

<style scoped>
</style>
